import React, { FC, useEffect, useState } from 'react';
import { SelectField, Option } from '@modernhealth/vital-components';
import ApolloClient from 'apollo-client';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import { MockApolloClient } from 'mock-apollo-client';

import { ClientSummaryNode } from 'src/generated/webapp_gql';

import {
  ClientSelectQuery,
  useClientSelectLazyQuery,
} from '../../documents/ClientSelectQuery.generated';
export interface Props {
  errorMessage?: string;
  memberClient: ApolloClient<NormalizedCacheObject> | MockApolloClient;
  onClientSelect: (selectedClient: ClientSummaryNode | undefined) => void;
}
const MemberSelector: FC<Props> = ({ errorMessage, memberClient, onClientSelect }) => {
  const [members, setMembers] = useState<Option[]>();
  const [fetchedData, setFetchedData] = useState<ClientSelectQuery>();
  const [selectedValue, setSelectedValue] = useState('');
  const [getClientSearchResults] = useClientSelectLazyQuery({
    client: memberClient,
    fetchPolicy: 'network-only',
    onCompleted: (data: ClientSelectQuery) => {
      setFetchedData(data);
      const results = data?.clients?.edges ?? [];

      if (!results) {
        throw new Error();
      }
      const members = results.reduce((accumulator: Option[], edge) => {
        if (edge?.node && edge?.node.coachAssignment?.active) {
          const { memberUuid, memberFirstName, memberLastName } = edge.node;
          return [
            ...accumulator,
            {
              value: memberUuid,
              label: `${memberFirstName} ${memberLastName}`,
            },
          ];
        }
        return accumulator;
      }, []);

      setMembers(members);
    },
  });

  useEffect(() => {
    getClientSearchResults();
  }, []);

  const onSelectMemember = (selectedMember: Option | null) => {
    const member = fetchedData?.clients?.edges.find(
      (x) => x?.node?.memberUuid === selectedMember?.value,
    )?.node;
    if (member) {
      onClientSelect(member);
    }
  };

  return (
    <SelectField
      options={members}
      label="Client"
      onChange={(option) => {
        setSelectedValue(option ? option.value : '');
        onSelectMemember(option);
      }}
      fieldId="MemberSelector"
      error={errorMessage}
      value={selectedValue}
    />
  );
};
export default MemberSelector;
